import { toRefs } from 'vue';
import { useGroup } from '../../compositions/component-lib.esm17.js';

//
var script = {
  name: 'InputBtnGroup',
  props: {
    value: {
      type: [Array, Number, String, Boolean],
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    multiple: Boolean,
    selectable: {
      type: Boolean,
      default: true
    },
    // Make a chip group scroll horizontally
    scroll: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value,
      multiple,
      selectable
    } = toRefs(props);

    // Warn if no ariaLabel or ariaLabelledby is provided
    if (!props.ariaLabel && !props.ariaLabelledby) {
      console.warn('ChipGroup: Provide either an aria-label or aria-labelledby prop for accessibility');
    }
    useGroup(value, val => emit('input', val), {
      multiple,
      selectable,
      groupName: 'chip-group'
    });
  }
};
export { script as default };